import es_cl from './es_cl';
// eslint-disable-next-line 
export default {
    ...es_cl,
    "text": {
        ...es_cl.text,
        "identification": "Dni",
    },
}